module.exports = __webpack_public_path__ + "img/team1.12ed5fd9.png";